export const mainHeader = 'Babysitter Jobs Guide'
export const para1 =
  'Welcome to the babysitter guide for learning more about the babysitting industry and how to find babysitting jobs.'
export const para2 =
  'If you are looking for babysitter jobs, you first need to be very informed about the types of babysitting services that are offered on the market and see which one would be fit for you. Babysitters should also have an expected pay rate before meeting with potential clients. You can check out Sitter.com and see what kind of candidates they are looking for. You can set up a profile and advertise your babysitting services all for free. '
export const para3 =
  'This guide is meant to inform you on how to be the best babysitter you can. Being an amazing babysitter is not only more enjoyable to the child, it’s also personally rewarding. Performing well will likely result in higher wages, more recommendations, and you intrinsically begin to enjoy babysitting more. '

export const secondHeader = 'What to do next'
export const secondPara =
  'Each of these articles can prepare you to be the best babysitter you can. Read through the ones that matter most to you and watch your skills grow!'
export const articles = [
  {
    title: 'Entertaining Ages 0-2',
    description:
      'Entertaining infants can be one of the easiest things to manage. Babies and toddlers are learning about the world around them and are often thrilled just to touch and see new things.',
    link: 'entertaining-ages-0-2',
  },
  {
    title: 'Entertaining Ages 2-5',
    description:
      'Preschools are curious, bossy and incredibly hyper, and entertaining them can be a very fun, yet tiring, endeaver.',
    link: 'entertaining-ages-0-2',
  },
  {
    title: 'Entertaining Ages 5-8',
    description:
      'Children between the ages of 5 and 8 become more independent. However, they often need attention and assistence in entertainment.',
    link: 'entertaining-ages-0-2',
  },
  {
    title: 'Entertaining Ages 8-12',
    description:
      'Entertaining ages 8-12 can be the hardest group to maintain as children within this group often want to do various different tasks a day',
    link: 'entertaining-ages-0-2',
  },
  {
    title: 'Understanding Behavior',
    description:
      'Children may react in confusing manners. Understanding the way they behave can help lead you to responding in appropriate manners.',
    link: 'entertaining-ages-0-2',
  },
  {
    title: 'Discipline Strategies',
    description:
      'Disciplining children can be one of the most difficult tasks. Learn how to effectively discipline them and what to avoid.',
    link: 'entertaining-ages-0-2',
  },
  {
    title: 'Child Nutrition Basics',
    description:
      'Nutrition at young age shapes a childs entire life. Learn the foods that will help them grow and how to avoid getting them sick',
    link: 'entertaining-ages-0-2',
  },
  {
    title: 'Safety First',
    description: 'Keeping a child safe should always be priority number 1!',
    link: 'entertaining-ages-0-2',
  },
  {
    title: 'Safety at Every Age',
    description: 'Children at different ages require different types of protectoin',
    link: 'entertaining-ages-0-2',
  },
  {
    title: 'Applying to a Babysitter Service',
    description:
      'Get some tips on how to WOW parents and get kids to love you when you first meet them',
    link: 'babysitter-services',
  },
  {
    title: 'Working With a Babysitting Agency',
    description:
      'Working with an agency is a good way to meet several clients and get a quick entrance into babysitting',
    link: 'babysitter-agencies',
  },
  {
    title: 'Successful Nannying',
    description:
      'What makes a good nanny? What qualities will help you be the best nanny or babysitter possible?',
    link: 'successful-nannying',
  },
  {
    title: 'Babysitter Business',
    description:
      'Learn the business behind the job: your target market, how your competitors are doing, marketing, and how to find valuable clients that are wo',
    link: 'babysitter-business',
  },
  {
    title: 'Money and Contracts',
    description: 'Setting up contracts, dealing with compensation',
    link: 'money-and-contracts',
  },
]
export const babysittingLinks = [
  {
    title: 'Babysitter Jobs Guide',
    link: 'babysitter-guide',
  },
  {
    title: 'Where to find babysitter jobs',
    link: 'babysitter-guide',
  },
  {
    title: 'How to Get a Job as a Babysitter',
    link: 'babysitter-guide',
  },
  {
    title: 'Applying to a Babysitter Service',
    link: 'babysitter-guide',
  },
  {
    title: 'What to Say in a Babysitter Job Interview',
    link: 'babysitter-guide',
  },
  {
    title: 'Setting your babysitter rates',
    link: '/setting-your-own-babysitter-rates',
  },
  {
    title: 'Money and Contracts',
    link: '/money-and-contracts',
  },
  {
    title: 'Working with a Babysitter Agency',
    link: '/babysitter-agencies',
  },
  {
    title: 'Babysitter Business',
    link: '/babysitter-business',
  },
  {
    title: 'How to Prepare for a Babysitting Job',
    link: '/how-to-prepare-for-a-babysitting-job',
  },
  {
    title: 'The Complete Babysitter Checklist',
    link: '/the-complete-babysitter-checklist',
  },
  {
    title: '17 Top Babysitting Tips',
    link: '/17-top-babysitting-tips',
  },
  {
    title: 'Safety First',
    link: '/safety-first',
  },
  {
    title: 'Safety at Every Age',
    link: '/safety-at-every-age',
  },
  {
    title: 'Child Nutrition Basics',
    link: '/child-nutrition-basics',
  },
  {
    title: 'Discipline Strategies',
    link: '/discipline-strategies',
  },
  {
    title: 'Understand Child Behavior',
    link: '/understanding-child-behavior',
  },
  {
    title: 'Successful Nannying',
    link: '/successful-nannying',
  },
  {
    title: 'Entertaining Ages 0-2',
    link: '/entertaining-ages-0-2',
  },
  {
    title: 'Entertaining Ages 2-5',
    link: 'entertaining-ages-0-2',
  },
  {
    title: 'Entertaining Ages 5-8',
    link: 'entertaining-ages-0-2',
  },
  {
    title: 'Entertaining Ages 8-12',
    link: 'entertaining-ages-0-2',
  },
  {
    title: 'Find Babysitting Jobs',
    link: 'https://sitter.com/babysitter-jobs',
  },
]
export const babysittingServices = [
  {
    title: 'How to Find a Babysitter',
    link: '/how-to-find-a-babysitter',
  },
  {
    title: 'Tips to Hire a Babysitter',
    link: '/tips-to-hire-a-babysitter',
  },
  {
    title: 'Babysitter Interview Questions',
    link: '/babysitter-interview-questions',
  },
  {
    title: 'What are the Typical Babysitter Rates?',
    link: '/what-are-the-typical-babysitter-rates',
  },
  {
    title: 'Running a Babysitter Background Check',
    link: '/running-a-babysitter-background-check',
  },
  {
    title: 'Where to Post a Babysitter Ad',
    link: '/where-to-post-a-babysitter-ad',
  },
  {
    title: 'Find Babysitters',
    link: 'https://sitter.com/sitters',
  },
]
